import React, { useState } from 'react';
import Select, { components, StylesConfig } from 'react-select';
import * as colors from 'src/styles/colors';
import { BsFillCaretDownFill } from 'react-icons/bs';

import { getCookie, setCookie } from 'typescript-cookie'
import { tryParseInt } from 'src/utils/formatters';

interface IPageSizeOption {
  value: number;
  label: string;
}

export const pageSizeOtions: Array<IPageSizeOption> = [
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 30, label: '30' },
  { value: 50, label: '50' },
];

type IsMulti = false;
const customStyles: StylesConfig<IPageSizeOption, IsMulti> = {
  control: (styles) => ({
    ...styles,
    cursor: 'pointer',
    height: '26px',
    borderRadius: '20px',
    border: 'none',
    boxShadow: 'none',
    minHeight: 'unset',
    '&:hover': {
      border: 'none',
      boxShadow: 'none',
    },
    '&:focus': {
      border: 'none',
      boxShadow: 'none',
    },
  }),
  singleValue: (styles) => ({
    ...styles,
    color: colors.BlueGray_400,
  }),
  menu: (styles) => ({
    ...styles,
    width: 'max-content',
    minWidth: '100%',
    boxShadow: '2px 2px 8px 1px' + colors.BlueGray_100,
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    cursor: 'pointer',
    padding: '8px 32px',
    textAlign: 'left',
    color: colors.BlueGray_400,
    backgroundColor: isDisabled
      ? undefined
      : isSelected
      ? colors.BlueGray_50
      : isFocused
      ? colors.BlueGray_50
      : undefined,
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: '0px 8px',
  }),
  input: (styles) => ({
    ...styles,
    padding: '0px 8px',
    margin: '0px',
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    fontSize: '10px',
  }),
};

interface IProps {
  onChange: (pageSize: number) => void;
}

/**
 * 分頁頁數切換。
 */
const PageSizeSelect: React.FC<IProps> = ({ onChange }) => {
  const [selectedPageSize, setSelectedPageSize] = useState<IPageSizeOption | null>(
    pageSizeOtions[getCookie('pageSize') == null ? 0 : pageSizeOtions.findIndex(e => e.value === Number(getCookie('pageSize')))],
  );

  const handlePageSizeChange = (option: IPageSizeOption | null) => {
    setSelectedPageSize(option);
    option && onChange(option.value);
    setCookie('pageSize', tryParseInt(option?.value));
  };

  return (
    <Select
      defaultValue={selectedPageSize}
      onChange={handlePageSizeChange}
      options={pageSizeOtions}
      menuPlacement="auto"
      components={{
        IndicatorSeparator: () => null,
        DropdownIndicator: (props) => (
          <components.DropdownIndicator {...props}>
            <BsFillCaretDownFill size="1.25em" />
          </components.DropdownIndicator>
        ),
      }}
      styles={customStyles}
      isSearchable={false}
    />
  );
};

export default PageSizeSelect;
